import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import SelectCourse from "@components/select-course/select-course";
import SelectExercise from "@components/select-exercise/select-exercise";
import Settings from "@components/settings/settings";
import Store from "@components/store/store";
import TestStringResults from "@components/test-string-results/test-string-results";
import Wrapper from "@components/wrapper/wrapper";
import WrapperChallengeComplete from "@components/wrapper-challenge-complete/wrapper-challenge-complete";
import WrapperCourseComplete from "@components/wrapper-course-complete/wrapper-course-complete";
import WrapperExerciseResults from "@components/wrapper-exercise-results/wrapper-exercise-results";
import WrapperLessonComplete from "@components/wrapper-lesson-complete/wrapper-lesson-complete";

import { formatUrlWithLocale } from "@helpers/format-url-with-locale";

import { ROUTES } from "./routes.constant";

export function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={formatUrlWithLocale(ROUTES.typingTutor.index)}
          element={<Wrapper />}
        >
          <Route path={ROUTES.typingTutor.settings} element={<Settings />} />
          <Route
            path={ROUTES.typingTutor.selectExercise}
            element={<SelectExercise />}
          />
          <Route
            path={ROUTES.typingTutor.selectCourse}
            element={<SelectCourse />}
          />
          <Route path={ROUTES.typingTutor.store} element={<Store />} />
        </Route>
        <Route
          path={formatUrlWithLocale(ROUTES.testStringResult)}
          element={<TestStringResults />}
        />
        <Route
          path={formatUrlWithLocale(ROUTES.exerciseResults)}
          element={<WrapperExerciseResults />}
        />
        <Route
          path={formatUrlWithLocale(ROUTES.challengeComplete)}
          element={<WrapperChallengeComplete />}
        />
        <Route
          path={formatUrlWithLocale(ROUTES.lessonComplete)}
          element={<WrapperLessonComplete />}
        />
        <Route
          path={formatUrlWithLocale(ROUTES.courseComplete)}
          element={<WrapperCourseComplete />}
        />
        <Route
          path='*'
          element={
            <Navigate to={formatUrlWithLocale(ROUTES.typingTutor.index)} />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
